import React from 'react';
import './InfoPage.css';

const Privacy: React.FC = () => {
  return (
    <div className="info-page">
      <div className="info-page-container">
        <h1>Privacy</h1>
        <p>
          Deferredly stores account and profile data to provide personalized admissions tools. We do not sell your
          personal information.
        </p>
        <p>
          We collect only the data needed to power your experience, including profile inputs, saved drafts, and account
          metadata.
        </p>
        <p>
          To request account data access or deletion, contact{' '}
          <a href="mailto:privacy@deferredly.com">privacy@deferredly.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
